/**
 * @description 链接转译 himo
 * @param path
 * @returns {string}
 */
export function linkTranslation (path) {
  const result = path
    .replace(/\?/g, '!')
    // eslint-disable-next-line
    .replace(/\&/g, '._~')
    // eslint-disable-next-line
    .replace(/\#/g, '-._')
    .replace(/=/g, '-.~')
  return result
}
